module.exports = __webpack_public_path__ + "static/media/naapurin-koneet-poimivat.2048d511.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/naapurin-koneet-poimivat.mp4
 ** module id = 461
 ** module chunks = 0
 **/